interface AppConfig {
  NODE_ENV: string
  REACT_APP_GOOGLE_RECAPTCHA_KEY: string
  REACT_APP_DOMAIN: string
  REACT_APP_API_URL: string
  REACT_APP_TAG: string | undefined
  WEB_CLIENT_ID: string
  IOS_CLIENT_ID: string
  APPLE_LOGIN_CLIENT_ID: string
  APPLE_LOGIN_SERVICE_ID: string
  APPLE_LOGIN_REDIRECT_URL: string
  OTA_ZIP_URL: string
  OTA_VERSION_URL: string
  SKIP_LIVE_UPDATE?: boolean
}

const {
  NODE_ENV,
  REACT_APP_GOOGLE_RECAPTCHA_KEY,
  REACT_APP_DOMAIN,
  REACT_APP_API_URL,
  REACT_APP_TAG,
  REACT_APP_WEB_CLIENT_ID,
  REACT_APP_IOS_CLIENT_ID,
  REACT_APP_APPLE_LOGIN_CLIENT_ID,
  REACT_APP_APPLE_LOGIN_SERVICE_ID,
  REACT_APP_APPLE_LOGIN_REDIRECT_URL,
  REACT_APP_OTA_ZIP_URL,
  REACT_APP_OTA_VERSION_URL,
  REACT_APP_SKIP_LIVE_UPDATE,
} = process.env

if (
  !NODE_ENV ||
  !REACT_APP_GOOGLE_RECAPTCHA_KEY ||
  !REACT_APP_DOMAIN ||
  !REACT_APP_API_URL ||
  !REACT_APP_WEB_CLIENT_ID ||
  !REACT_APP_IOS_CLIENT_ID ||
  !REACT_APP_APPLE_LOGIN_CLIENT_ID ||
  !REACT_APP_APPLE_LOGIN_SERVICE_ID ||
  !REACT_APP_APPLE_LOGIN_REDIRECT_URL ||
  !REACT_APP_OTA_ZIP_URL ||
  !REACT_APP_OTA_VERSION_URL
) {
  // eslint-disable-next-line no-console
  console.log('NODE_ENV:', NODE_ENV)
  // eslint-disable-next-line no-console
  console.log('env:', process.env)
  throw new Error('Missing required environment variables')
}

export const appConfig: AppConfig = {
  NODE_ENV,
  REACT_APP_GOOGLE_RECAPTCHA_KEY: REACT_APP_GOOGLE_RECAPTCHA_KEY,
  REACT_APP_DOMAIN: REACT_APP_DOMAIN,
  REACT_APP_API_URL: REACT_APP_API_URL,
  REACT_APP_TAG: REACT_APP_TAG,
  WEB_CLIENT_ID: REACT_APP_WEB_CLIENT_ID,
  IOS_CLIENT_ID: REACT_APP_IOS_CLIENT_ID,
  APPLE_LOGIN_CLIENT_ID: REACT_APP_APPLE_LOGIN_CLIENT_ID,
  APPLE_LOGIN_SERVICE_ID: REACT_APP_APPLE_LOGIN_SERVICE_ID,
  APPLE_LOGIN_REDIRECT_URL: REACT_APP_APPLE_LOGIN_REDIRECT_URL,
  OTA_ZIP_URL: REACT_APP_OTA_ZIP_URL,
  OTA_VERSION_URL: REACT_APP_OTA_VERSION_URL,
  SKIP_LIVE_UPDATE: REACT_APP_SKIP_LIVE_UPDATE === 'true',
}
